angular.module('picmonic-common').controller('RegisterStep1Controller', [
  '$rootScope',
  '$scope',
  '$location',
  '$q',
  '$filter',
  'UserService',
  'MarketOptionsConfig',
  '$cookies',
  'MarketSelectorModalService',
  function (
    $rootScope,
    $scope,
    $location,
    $q,
    $filter,
    UserService,
    MarketOptionsConfig,
    $cookies,
    MarketSelectorModalService
  ) {
    //initialize datalayer for gtm

    $scope.user = UserService.user;

    //Set redirect variable to be displayed in <a href>
    $scope.redirect = $location.search().redirect ? encodeURIComponent($location.search().redirect) : '';
    $scope.$emit('endInteraction');

    // Set user variables from URL parameters
    var urlparams = $location.search();

    if (urlparams.first_name) {
      $scope.user.first_name = decodeURIComponent(urlparams.first_name);
    }
    if (urlparams.last_name) {
      $scope.user.last_name = decodeURIComponent(urlparams.last_name);
    }

    if (urlparams.email) {
      $scope.user.email = decodeURIComponent(urlparams.email);
    }

    if (urlparams.job_title) {
      $scope.user.title = urlparams.job_title;
      UserService.setCookieIfNotLoggedIn('registrationUserJobTitle', decodeURIComponent(urlparams.job_title));
    }

    if (urlparams.lead) {
      UserService.setCookieIfNotLoggedIn('lead', parseInt(urlparams.lead, 10));
    }

    if (urlparams.role) {
      $scope.user.role = decodeURIComponent(urlparams.role);
      UserService.setCookieIfNotLoggedIn('role', urlparams.role == 'Professor' ? urlparams.role : 'Student');
    }

    // Picmonic Registration
    $scope.register = function (redirect, redirectUrl) {
      // Parse full name
      if ($scope.user.full_name) {
        parsedName = UserService.parseFullName($scope.user.full_name);
        $scope.user.first_name = parsedName['first_name'];
        $scope.user.last_name = parsedName['last_name'];
      }

      // Registration Source Page
      if ($scope.registration_source_page) {
        $scope.user.registration_source_page = $scope.registration_source_page;
      }

      // Market and Program
      if ($scope.user.selected_lead) {
        $scope.user.lead = $scope.user.selected_lead;
      }
      var result = UserService.register(redirect, redirectUrl);
      result.then(
        function () {},
        function (error) {
          $scope.error = error.data.message_html;
          $scope.loading = false;
          return $q.reject(error);
        }
      );
      return result;
    };

    //Facebook Registration
    $scope.socialRegister = function (redirect, redirectUrl) {
      promise = $q.defer();

      if (!$cookies.get('pls_user_lead')) {
        MarketSelectorModalService.showMarketSelectorModal(null, true, true).result.then(
          function () {
            promise.resolve();
          },
          function () {
            promise.reject();
          }
        );
      } else {
        promise.resolve();
      }

      return promise.promise.then(function () {
        $scope.loading = true;
        $scope.loadingMode = 'registration-social';
        $scope.error = '';
        return UserService.socialRegister(redirect, redirectUrl).then(null, function (error) {
          $scope.error =
            error && error.data.message
              ? error.data.message
              : 'Not Authorized. You must click "Okay" when the Login with Facebook pop up opens.';
          $scope.loading = false;
          return $q.reject(error);
        });
      });
    };

    $scope.googleRegister = function (redirect, redirectUrl) {
      promise = $q.defer();

      if (!$cookies.get('pls_user_lead')) {
        MarketSelectorModalService.showMarketSelectorModal(null, true, true).result.then(
          function () {
            promise.resolve();
          },
          function () {
            promise.reject();
          }
        );
      } else {
        promise.resolve();
      }

      return promise.promise.then(function () {
        $scope.loading = true;
        $scope.loadingMode = 'registration-google';
        $scope.error = '';
        return UserService.googleRegister(redirect, redirectUrl).then(null, function (error) {
          $scope.error = 'You must login when the Google popup opens';
          $scope.loading = false;
          return $q.reject(error);
        });
      });
    };

    // Submit Picmonic Registraiton Form
    $scope.submitRegistration = function (redirect) {
      if ($scope.registration.$valid) {
        if (!$scope.loading) {
          $scope.loading = true;
          $scope.loadingMode = 'registration-picmonic';
          $scope.error = '';
          $scope.user.accessToken = null;
          $scope.register(redirect);
        }
      } else {
        $scope.error = 'Please complete all required fields';
        $scope.registration.$setDirty();
        angular.forEach($scope.registration.$error, function (field) {
          angular.forEach(field, function (errorField) {
            errorField.$setTouched();
          });
        });
      }
    };
  },
]);
